import { Intent } from "@blueprintjs/core";
import { type ValidationError } from "class-validator";

export function getComponentIntent<T>(
  property: keyof T,
  errors: ValidationError[] = [],
  defaultIntent: Intent = Intent.NONE,
): Intent {
  let intent: Intent = defaultIntent;

  if (intent === Intent.DANGER) {
    return intent;
  }

  errors.some((error) => {
    if (error.property === property) {
      intent = Intent.DANGER;
      return true;
    }

    if (error.children) {
      intent = getComponentIntent(property, error.children, intent);

      if (intent === Intent.DANGER) {
        return true;
      }
    }

    return false;
  });

  return intent;
}

export function getComponentHelperText<T>(
  property: keyof T,
  errors: ValidationError[] = [],
  defaultHelperText: string = "",
): string {
  let helperText: string = defaultHelperText;

  errors.some((error) => {
    if (error.property === property && error.constraints) {
      helperText = Object.values(error.constraints).join(", ");
      return true;
    }

    if (error.children) {
      helperText = getComponentHelperText(property, error.children);

      if (helperText) {
        return true;
      }
    }

    return false;
  });

  return helperText;
}
